/**
 * region for libraries*/
import React, { Component } from 'react';

/**
 * region for component*/
import { WorkingLayer } from '../../../../components/common/WorkingLayer';

/**
 * region for helpers*/
import ajax from '../../../../helpers/ajax';
import typing from '../../../../helpers/typing';

/**
 * region for constants*/
import Constants from '../../../../constants/Constants'

export class DetailHistoryKeyword extends Component {
    static displayName = DetailHistoryKeyword.name;

    constructor(props) {
        super(props);
        this.state = {
            showDetailLayer: this.props.showDetailLayer,
            mode: Constants.MODE_LOADING,
            rows: [],
            detailParentRow: this.props.detailParentRow,
            idExpandedRow: undefined
        };

        this.currentPage = 1;
        this.MAXITEMSSHOWED = 2;
    }

    load() {

        const self = this;

        let requestData = {
            idEntity: this.state.detailParentRow.IDENTITY,
            idEntityType: this.state.detailParentRow.IDCONTENTORGANIZATIONTYPE,
        };

        ajax.get(Constants.ROUTE_API_CONTENTORGANIZATION_DETAILS,
            {
                requestData: requestData,
                success: function (response) {
                    self.setState({
                        rows: response.data,
                        mode: Constants.MODE_LOADED
                    });
                }
            });
    }

    componentDidMount() {
        this.load();
    }

    handleCloseShowDetailLayer(event) {
        event.preventDefault();
        if (this.props.onCloseDetailLayer) {
            this.props.onCloseDetailLayer();
        }
        this.setState({ showDetailLayer: false });
    }

    handleSetToggleExpanded(idRow, event) {
        event.preventDefault();
        if (this.state.idExpandedRow === idRow) {
            this.setState({
                idExpandedRow: undefined
            });
        } else {
            this.setState({
                idExpandedRow: idRow
            });
        }
    }

    getShortValuesString(values) {
        if (values.length > this.MAXITEMSSHOWED) {
            return values.slice(0, this.MAXITEMSSHOWED).join(', ') + '...';
        }
        else {
            return values.join(', ');
        }
    }

    getRenderedRow(row) {
        let listOldValues = row.OLDVALUES ? row.OLDVALUES.split(',') : [];
        let listNewValues = row.NEWVALUES ? row.NEWVALUES.split(',') : [];

        let mainRowClass;
        if (this.state.idExpandedRow === row.IDCONTENTORGANIZATIONLOG) {
            mainRowClass = 'toggle-collapse-container'
        }

        let firstCell;
        if (listNewValues.length > this.MAXITEMSSHOWED || listOldValues.length > this.MAXITEMSSHOWED) {
            firstCell = <th scope="row" className={mainRowClass}><i className="fas fa-caret-down"></i></th>
        } else {
            firstCell = <th scope="row"></th>
        }
        let showFirstOldValues;
        let showFirstNewValues;

        if (this.state.idExpandedRow === row.IDCONTENTORGANIZATIONLOG) {
            showFirstOldValues = listOldValues.join(', ');
            showFirstNewValues = listNewValues.join(', ');
        } else {
            showFirstOldValues = this.getShortValuesString(listOldValues);
            showFirstNewValues = this.getShortValuesString(listNewValues);
        }

        return <tr key={row.IDCONTENTORGANIZATIONLOG} onClick={this.handleSetToggleExpanded.bind(this, row.IDCONTENTORGANIZATIONLOG)}>
            {firstCell}
            <td className="w-120">{typing.convertToDateShortMonth(row.DATE)}</td>
            <td>{row.USERNAME}</td>
            <td>{showFirstOldValues}</td>
            <td>{showFirstNewValues}</td>
            <td></td>
        </tr>;
    }


    render() {

        if (this.state.mode === Constants.MODE_LOADING) {
            return <WorkingLayer />
        }

        let containerData;
        let showData=<table className="table">
                        <thead>
                            <tr className="bt-none">
                                <th></th>
                                <th className="w-120">Date</th>
                                <th>User</th>
                                <th>Before</th>
                                <th>After</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.rows.map(row => this.getRenderedRow(row))}
                        </tbody>
                    </table>;

        if(this.props.showOnlyTable){
            containerData= <div>
                                {showData}
                           </div>
  
        }else{
            containerData=<div className="detail-layer">
            <button type="button" className="close close-detail" onClick={this.handleCloseShowDetailLayer.bind(this)}>
                <span>X</span>
            </button>
            <h5 className="mt-7">{this.state.detailParentRow.TYPENAME}</h5>
            <h4>{this.state.detailParentRow.NAMEENTITY}</h4>
            <div className="table-responsive">
                {showData}
            </div>
        </div>
        }

        return (
           <div>{containerData}</div>
        );
    }
}
